const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.16 1.3335H7.56389C6.38773 1.33349 5.45612 1.33348 4.72703 1.4319C3.97668 1.53318 3.36935 1.74659 2.8904 2.22747C2.41144 2.70834 2.19889 3.31811 2.09801 4.07147C1.99998 4.8035 1.99999 5.73884 2 6.91973V10.8114C2 11.8168 2.6133 12.6784 3.48478 13.0396C3.43992 12.4333 3.43996 11.5826 3.44 10.8749L3.44 7.59856L3.44 7.5351C3.43995 6.68066 3.43991 5.94445 3.51886 5.3549C3.60346 4.72308 3.79426 4.11744 4.28353 3.6262C4.77281 3.13496 5.37602 2.9434 6.00532 2.85845C6.59251 2.77919 7.32578 2.77923 8.1768 2.77928L8.24 2.77928H10.16L10.2232 2.77928C11.0742 2.77923 11.8059 2.77919 12.3931 2.85845C12.0418 1.96535 11.1744 1.3335 10.16 1.3335Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40015 7.5981C4.40015 5.78063 4.40015 4.8719 4.9625 4.30729C5.52486 3.74268 6.42995 3.74268 8.24015 3.74268H10.1601C11.9703 3.74268 12.8754 3.74268 13.4378 4.30729C14.0001 4.8719 14.0001 5.78063 14.0001 7.5981V10.8109C14.0001 12.6284 14.0001 13.5371 13.4378 14.1018C12.8754 14.6664 11.9703 14.6664 10.1601 14.6664H8.24015C6.42995 14.6664 5.52486 14.6664 4.9625 14.1018C4.40015 13.5371 4.40015 12.6284 4.40015 10.8109V7.5981Z",
    fill: "black",
    style: {
      fill: "black",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.bf8bcc0784d405f1875d744b79412b69.svg";
export { ForwardRef as ReactComponent };